import { create } from "zustand";
import { Mimshak } from "../interfaces/DTO/mislaka_xml_models";

// קבוע שמגדיר את מספר האלמנטים המקסימלי
const MAX_LIMIT = 10;

export interface MimshakStoreRecordItem {
  filename: string; // שם הקובץ
  timestamp: string; // תאריך ושעה של העלאה
  mimshaks: Mimshak[]; // רשימה של אובייקטים מסוג Mimshak
}

interface MimshakStore {
  records: Record<number, MimshakStoreRecordItem>;
  selectedItem: number | null;
  secondarySelectedItem: number | null;

  addOrUpdateRecord: (userId: number, recordItem: MimshakStoreRecordItem) => void;
  getUserMimshak: (userId: number) => MimshakStoreRecordItem | null;
  setSelectedItem: (userId: number) => void;
  setSecondarySelectedItem: (userId: number) => void;
}

export const useMimshakStore = create<MimshakStore>((set, get) => ({
  records: {},
  selectedItem: null,
  secondarySelectedItem: null,

  /**
   * Add or update a record for a specific user.
   * @param userId - The ID of the user.
   * @param recordItem - The record item to add or update.
   */
  addOrUpdateRecord: (userId: number, recordItem: MimshakStoreRecordItem) => {
    set((state) => {
      const existingRecord = state.records[userId];
      const updatedMimshaks = existingRecord
        ? [...existingRecord.mimshaks, ...recordItem.mimshaks].slice(-MAX_LIMIT)
        : recordItem.mimshaks.slice(-MAX_LIMIT);

      return {
        records: {
          ...state.records,
          [userId]: {
            filename: recordItem.filename,
            timestamp: recordItem.timestamp,
            mimshaks: updatedMimshaks,
          },
        },
      };
    });
  },

  /**
   * Get Mimshak data for a specific user.
   * @param userId - The ID of the user.
   * @returns MimshakStoreRecordItem or null if not found.
   */
  getUserMimshak: (userId: number) => {
    const state = get();
    return state.records[userId] || null;
  },

  /**
   * Set the selected item.
   * @param userId - The ID of the user.
   */
  setSelectedItem: (userId: number) => {
    set({ selectedItem: userId });
  },

  /**
   * Set the secondary selected item.
   * @param userId - The ID of the user.
   */
  setSecondarySelectedItem: (userId: number) => {
    set({ secondarySelectedItem: userId });
  },
}));
